import { componentThemes } from "@moodys/mdc-frontend.theming.mui-themes.component-themes";
import { darkPalette, palette, } from "@moodys/mdc-frontend.theming.mui-themes.palettes.palette";
import { shadows } from "@moodys/mdc-frontend.theming.mui-themes.shadows";
import { getTypographyFontSizes, typography, } from "@moodys/mdc-frontend.theming.mui-themes.typography.typography";
import { createTheme, } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { removeResponsiveFontStyles } from "./typography.utils";
const moodysPaletteOptions = {
    darkMode: darkPalette,
    lightMode: palette,
};
export const moodysThemeCreator = (params) => {
    const { mode = params.parentTheme.palette?.mode ?? "light", parentTheme, themeOverrides, responsiveFontSizes = true, } = params;
    let overrides = typeof themeOverrides === "function"
        ? themeOverrides({ mode })
        : themeOverrides;
    const moodysPalette = parentTheme.moodys
        ? parentTheme.moodys.palettes
        : moodysPaletteOptions;
    if (overrides?.typography?.htmlFontSize &&
        overrides.typography.htmlFontSize !== parentTheme.typography?.htmlFontSize) {
        overrides = deepmerge({
            typography: getTypographyFontSizes({
                htmlFontSize: overrides.typography.htmlFontSize,
                includeResponsiveStyles: responsiveFontSizes,
            }),
        }, overrides);
    }
    const themeOptions = deepmerge(deepmerge(parentTheme, {
        palette: {
            ...(mode === "dark" ? moodysPalette.darkMode : moodysPalette.lightMode),
            mode,
        },
    }), overrides);
    if (!responsiveFontSizes && themeOptions.typography) {
        removeResponsiveFontStyles({
            typography: themeOptions.typography,
        });
    }
    return createTheme(themeOptions);
};
export const baseThemeOptions = {
    typography,
    components: componentThemes,
    shadows,
    moodys: {
        palettes: {
            ...moodysPaletteOptions,
        },
    },
};
//# sourceMappingURL=moodys-theme-creator.js.map